import React from 'react';
import './Card.css';

interface CardProps {
  icon: any; // Icon can be an SVG or any React element
  title: string; // Title text
  subtitle: string; // Subtitle text
  variant?: string;
}



const Card: React.FC<CardProps> = ({ icon, title, subtitle, variant="primary" }) => {
  return (
    <div className={`card card-${variant}`}>
      <div className='card-icon'>{icon}</div>
        <div className='card-content'>
        <h2 className="card-title">{title}</h2>
        <p className="card-subtitle">{subtitle}</p>
        </div>
    </div>
  );
};

export default Card;
